import React from "react";
import { Button, Paper, Stack, Typography } from "@mui/material";
import EditNote from "@mui/icons-material/EditNote";

interface Props {
  onClick: () => void;
}

export const UpdateCredentialsCard: React.FC<Props> = ({ onClick }) => (
  <Paper
    elevation={0}
    sx={{
      p: 3,
      borderRadius: 3,
      border: "1px solid",
      borderColor: "divider",
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        borderColor: "primary.main",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        transform: "translateY(-2px)",
      },
    }}
    onClick={onClick}
  >
    <Stack spacing={2}>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <EditNote sx={{ color: "primary.main" }} />
        <Typography variant="subtitle1" fontWeight={700}>
          Update Credentials
        </Typography>
      </Stack>
      <Typography variant="body2" color="text.secondary">
        If your vendor has new credentials, update them here to keep the integration working.
      </Typography>
      <Button
        variant="outlined"
        onClick={onClick}
        sx={{
          alignSelf: "flex-start",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        Update Credentials
      </Button>
    </Stack>
  </Paper>
);
